/**
 * Cisco IOS CLI Configuration Generator
 * Converts calculated subnet parameters into copy-ready Cisco IOS CLI scripts:
 * - Interface IP configuration (GigabitEthernet, VLAN/SVI, Subinterfaces)
 * - OSPF Routing Network Statements
 * - Standard & Extended Access Control Lists (ACLs)
 * - Cisco DHCP Server Pool
 * - Static IP Routes
 */

export function generateCiscoInterfaceConfig(subnetData, options = {}) {
  const iface = options.interface || 'GigabitEthernet0/0/1';
  const ip = options.ip || subnetData.firstUsable;
  const desc = options.description || `LAN Gateway for ${subnetData.networkAddress}/${subnetData.cidr}`;

  return `! ==========================================
! Cisco IOS Interface Configuration
! Subnet: ${subnetData.networkAddress}/${subnetData.cidr}
! ==========================================
configure terminal
interface ${iface}
 description ${desc}
 ip address ${ip} ${subnetData.subnetMask}
 no shutdown
 exit
`;
}

export function generateCiscoOspfConfig(subnetData, options = {}) {
  const processId = options.processId || 1;
  const area = options.area !== undefined ? options.area : 0;

  return `! ==========================================
! Cisco IOS OSPF Routing Protocol Statement
! Subnet: ${subnetData.networkAddress}/${subnetData.cidr}
! Uses Inverted Wildcard Mask: ${subnetData.wildcardMask}
! ==========================================
configure terminal
router ospf ${processId}
 router-id ${subnetData.firstUsable}
 network ${subnetData.networkAddress} ${subnetData.wildcardMask} area ${area}
 exit
`;
}

export function generateCiscoAclConfig(subnetData, options = {}) {
  const aclNumber = options.aclNumber || 10;
  const aclName = options.aclName || 'CORP-SEC-FILTER';

  return `! ==========================================
! Cisco IOS Access Control List (ACL) Statements
! Subnet: ${subnetData.networkAddress}/${subnetData.cidr}
! ==========================================
configure terminal

! --- Standard Numbered ACL ---
access-list ${aclNumber} remark Allow traffic from ${subnetData.networkAddress}/${subnetData.cidr}
access-list ${aclNumber} permit ${subnetData.networkAddress} ${subnetData.wildcardMask}

! --- Named Extended ACL ---
ip access-list extended ${aclName}
 remark Permit TCP/UDP outbound from subnet
 permit tcp ${subnetData.networkAddress} ${subnetData.wildcardMask} any eq 443
 permit tcp ${subnetData.networkAddress} ${subnetData.wildcardMask} any eq 80
 permit udp ${subnetData.networkAddress} ${subnetData.wildcardMask} any eq 53
 permit icmp ${subnetData.networkAddress} ${subnetData.wildcardMask} any echo
 deny ip any any log
 exit
`;
}

export function generateCiscoDhcpConfig(subnetData, options = {}) {
  const poolName = options.poolName || `POOL_${subnetData.networkAddress.replace(/\./g, '_')}`;
  const dnsServer = options.dnsServer || '8.8.8.8 1.1.1.1';
  const defaultRouter = options.defaultRouter || subnetData.firstUsable;

  return `! ==========================================
! Cisco IOS DHCP Server Pool Configuration
! Subnet: ${subnetData.networkAddress}/${subnetData.cidr}
! ==========================================
configure terminal

! Exclude Gateway IP from DHCP Lease Pool
ip dhcp excluded-address ${defaultRouter}

! Configure DHCP Scope
ip dhcp pool ${poolName}
 network ${subnetData.networkAddress} ${subnetData.subnetMask}
 default-router ${defaultRouter}
 dns-server ${dnsServer}
 domain-name corporate.local
 lease 7
 exit
`;
}

export function generateCiscoStaticRouteConfig(subnetData, options = {}) {
  const nextHop = options.nextHop || '10.0.0.1';

  return `! ==========================================
! Cisco IOS Static Route Configuration
! Route to ${subnetData.networkAddress}/${subnetData.cidr}
! ==========================================
configure terminal
ip route ${subnetData.networkAddress} ${subnetData.subnetMask} ${nextHop}
`;
}
